import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import UpdateLoanAsset from "Communication/ApiClasses/UpdateLoanAssetRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleUpdateLoanAsset(action) {
  yield put(doLoadingStart(STRINGS.ASSET.API_KEYS.LOAN_UPDATE_ASSET));
  const updateLoanAsset = new UpdateLoanAsset(
    action.data.applicantId,
    action.data.finAnalysisId,
    action.data.financialId,
    action.data.payLoad
  );
  try {
    const result = yield call(updateLoanAsset.getData);
    yield put({
      type: actionTypes.LOAN_UPDATE_ASSET_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_UPDATE_ASSET_ERROR,
      error: e.message,
    });
  } finally {
    yield put(doLoadingFinish(STRINGS.ASSET.API_KEYS.LOAN_UPDATE_ASSET));
  }
}

// watcher
function* updateLoanAssetWatcherSaga() {
  yield takeLatest(actionTypes.LOAN_UPDATE_ASSET, handleUpdateLoanAsset);
}

export default updateLoanAssetWatcherSaga;
